import {
  IOrder,
  RefundReason,
  RefundType,
  TransactionType,
} from '@Encore-FastStartup-Phase-Out/encore-shared';
import { makeAutoObservable } from 'mobx';

import { TransactionApi } from '../api/TransactionApi';
import { UpdateOrderDto } from '../constants/types';

import { ListingStore } from './ListingStore';

export class OrderStore {
  api: TransactionApi;
  listingStore: ListingStore;
  displayedListingOrder: IOrder | undefined = undefined;
  refundRemainingPrice: number = 0;

  constructor(listingStore: ListingStore) {
    this.api = new TransactionApi();
    this.listingStore = listingStore;
    makeAutoObservable(this, undefined, { autoBind: true });
  }

  setDisplayedListingOrder(order: IOrder) {
    this.displayedListingOrder = order;
  }

  setRefundRemainingPrice(refundRemainingPrice: number) {
    this.refundRemainingPrice = refundRemainingPrice;
  }

  async getOrderWithTransactions() {
    const order = await this.api.getOrderWithTransactions(
      this.listingStore.displayedSoldListing.id,
    );
    this.setDisplayedListingOrder(order);
  }

  async getRefundRemainingPrice(refundType?: RefundType) {
    if (!this.displayedListingOrder || !refundType) {
      return;
    }
    const price = await this.api.getOrderRefundRemaining(
      this.displayedListingOrder.id,
      refundType,
    );
    this.setRefundRemainingPrice(price);
  }

  async handleRefund(
    refundReason: RefundReason,
    refundType: RefundType,
    amount?: number,
  ) {
    if (!this.displayedListingOrder) return;

    const updatedOrder = await this.api.refundOrder(
      this.displayedListingOrder.id,
      refundReason,
      refundType,
      amount,
    );

    this.setDisplayedListingOrder(updatedOrder);
  }

  async updateOrder(updateOrderDto: UpdateOrderDto) {
    if (this.displayedListingOrder) {
      await this.api.updateOrder(this.displayedListingOrder.id, updateOrderDto);
    }
  }

  async makeOrderPayout() {
    if (this.displayedListingOrder) {
      await this.api.makeOrderPayout(this.displayedListingOrder.id);
    }
  }

  async createAdminTransaction(creditValue: number, transactionType: TransactionType) {
    await this.api.createCreditTransaction(creditValue, transactionType);
  }
}
